<template>
	<div class="unitdetails">
		<el-breadcrumb separator-class="el-icon-arrow-right" style="margin: 24px;">
		  <el-breadcrumb-item :to="{ path: '/Worktable' }">资质单位</el-breadcrumb-item>
		  <el-breadcrumb-item>单位详情</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="step">
			<div class="step_title">新办申请</div>
			<div class="step_content">
				<!-- <div class="item">
					选择单位
				</div -->
				<step :active.sync="active" :stepArr="stepArr" :width="width"></step>
			</div>
		</div>
		<div class="content">
			<!-- 选择单位 -->
			<div v-if="active==0">
				<div class="title">
					选择单位
				</div>
				<div class="content_box">
					<el-input placeholder="请输入单位关键词" v-model="value">
						<template slot="suffix">
							<i class="el-icon-plus" style="line-height: 40px;color: #627eea;">新增单位</i>
						</template>
					</el-input>
				</div>
			</div>
			<!-- 选择资质 -->
			<div v-if="active==1">
				<div class="title">
					请选择要申请的资质
				</div>
				<div class="qualification">
					<div class="qualification_item">
						<div class="item_title">
							<i class="el-icon-notebook-2" style="color: #44b4ad;"></i>
							军工资质
						</div>
						<div class="item_cont">
							<div class="contdome" v-for="(i,ix) in militarys"
								:class="{'contdome_active':ismilitary==ix}" @click="military(ix)">
								{{i}}
								<img v-if="ismilitary==ix" src="@/assets/images/11639@3x.png" alt="">
							</div>
						</div>
					</div>
					<div class="qualification_item">
						<div class="item_title">
							<i class="el-icon-notebook-2" style="color: firebrick;"></i>
							集成资质甲级
						</div>
						<div class="item_cont">
							<div class="contdome" v-for="(i,ix) in integratedGradeA"
								:class="{'contdome_active':isGradeA==ix}">
								{{i}}
								<img v-if="isGradeA==ix" src="@/assets/images/11639@3x.png" alt="">
							</div>
						</div>
						<div class="item_title">
							<i class="el-icon-notebook-2" style="color: orange;"></i>
							集成资质乙级
						</div>
						<div class="item_cont">
							<div class="contdome" v-for="(i,ix) in integratedGradeB"
								:class="{'contdome_active':isGradeB==ix}">
								{{i}}
								<img v-if="isGradeB==ix" src="@/assets/images/11639@3x.png" alt="">
							</div>
						</div>
					</div>
					<div class="qualification_item">
						<div class="item_title">
							<i class="el-icon-notebook-2" style="color: saddlebrown;"></i>
							集成资质甲级
						</div>
						<div class="item_cont">
							<div class="contdome" v-for="(i,ix) in carrierA" :class="{'contdome_active':iscarrierA==ix}"
								>
								{{i}}
								<img v-if="iscarrierA==ix" src="@/assets/images/11639@3x.png" alt="">
							</div>
						</div>
						<div class="item_title">
							<i class="el-icon-notebook-2" style="color: #44b4ad;"></i>
							集成资质乙级
						</div>
						<div class="item_cont">
							<div class="contdome" v-for="(i,ix) in carrierB" :class="{'contdome_active':iscarrierB==ix}"
								>
								{{i}}
								<img v-if="iscarrierB==ix" src="@/assets/images/11639@3x.png" alt="">
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 处理资料 -->
			<div v-if="active==2">
				<div class="title">
					材料处理
				</div>
				<el-table class="my_table" :data="tableData" style="width: 100%" stripe>
					<el-table-column prop="date" label="申请资质名称" width="500">
						<template slot-scope="scope">
							<div class="column">
								<img src="@/assets/images/print.png" alt="">
								{{scope.row.date}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="申请等级" sortable></el-table-column>
					<el-table-column prop="address" label="资质类别" sortable></el-table-column>
					<el-table-column prop="status" label="状态" sortable>
						<template slot-scope="scope">
							<span :style="{color:(scope.row.status === '0' ? '#8a3aed':'#0147eb')}">
								{{scope.row.status==='0'?'材料待处理':'材料齐全'}}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button type="text"><i class="el-icon-document-checked"></i>材料齐全</el-button>
							<el-button type="text"><i class="el-icon-document-delete"></i>材料不齐全</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 清单信息 -->
			<div v-if="active==3">
				<div class="title">
					清单信息
				</div>
				<div class="list_box">
					<div class="list_title">
						当前选中
					</div>
					<div class="check_box">
						<div class="item">
							<span>腾杰广告有限公司</span>
							<span>
								<img src="@/assets/images/print.png" alt="">
								印制资质</span>
							<span>甲级</span>
							<span>涉密文件资料</span>
							<span>材料齐全</span>
						</div>
						<div class="item">
							<span>腾杰广告有限公司</span>
							<span>
								<img src="@/assets/images/industry.png" alt="">
								印制资质</span>
							<span>甲级</span>
							<span>涉密文件资料</span>
							<span>材料齐全</span>
						</div>
						<div class="item">
							<span>腾杰广告有限公司</span>
							<span>
								<img src="@/assets/images/qualification.png" alt="">
								印制资质</span>
							<span>甲级</span>
							<span>涉密文件资料</span>
							<span>材料齐全</span>
						</div>
					</div>
					<div class="list_title">
						请填写清单信息
					</div>
					<div class="info_box">
						<div class="info_title">
							集成资质 乙级 系统咨询
						</div>
						<div class="info_item" v-for="(item,index) in infoLsit">
							<el-form :model="item" ref="item" label-width="100px">
								<el-row>
									<el-col :span="5">
										<el-form-item label="清单类型：" prop="type">
											<el-select v-model="item.type" placeholder="请选择">
												<el-option v-for="i in options" :key="i.value" :label="i.label"
													:value="i.value">
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :span="5">
										<el-form-item label="数量：" prop="num">
											<el-input-number v-model="item.num" controls-position="right" :min="1"
												:max="10"></el-input-number>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item label="备注：：" prop="type">
											<el-input v-model="item.type" placeholder="请输入备注"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="6">
										<div class="operate_box">
											<i class="el-icon-circle-plus-outline" style="color: #0147eb;"></i>
											<i class="el-icon-remove-outline"
												v-if="infoLsit.length==index+1&&infoLsit.length>1"
												style="color: #f04444;"></i>
										</div>
									</el-col>
								</el-row>
							</el-form>
						</div>
					</div>
					<div class="info_box">
						<div class="info_title">
							集成资质 乙级 系统咨询
						</div>
						<div class="info_item" v-for="(item,index) in infoLsit">
							<el-form :model="item" ref="item" label-width="100px">
								<el-row>
									<el-col :span="5">
										<el-form-item label="清单类型：" prop="type">
											<el-select v-model="item.type" placeholder="请选择">
												<el-option v-for="i in options" :key="i.value" :label="i.label"
													:value="i.value">
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :span="5">
										<el-form-item label="数量：" prop="num">
											<el-input-number v-model="item.num" controls-position="right" :min="1"
												:max="10"></el-input-number>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item label="备注：：" prop="type">
											<el-input v-model="item.type" placeholder="请输入备注"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="6">
										<div class="operate_box">
											<i class="el-icon-circle-plus-outline" style="color: #0147eb;"></i>
											<i class="el-icon-remove-outline"
												v-if="infoLsit.length==index+1&&infoLsit.length>1"
												style="color: #f04444;"></i>
										</div>
									</el-col>
								</el-row>
							</el-form>
						</div>
					</div>
				</div>
			</div>
			<!-- 请确定经办人信息 -->
			<div v-if="active==4">
				<div class="title">
					请确定经办人信息
				</div>
				<div class="agent_box">
					<div class="agent_item" v-for="(a,ai) in agentList" :class="{'agent_active':isagents==ai}"
						@click="agent(ai)">
						<div class="item_img">
							<img src="@/assets/images/10953@3x.png" alt="">
						</div>
						<div class="item_info">
							<div>
								{{a.name}}
							</div>
							<div><i class="el-icon-postcard"></i>{{a.card}}</div>
							<div><i class="el-icon-mobile-phone"></i>{{a.phone}}</div>
						</div>
						<img class="isagent" v-if="isagents==ai" src="@/assets/images/11639@3x.png" alt="">
					</div>
					<div class="agent_add">
						<i class="el-icon-plus"> 新增人员</i>
					</div>
				</div>
			</div>
			<!-- 完成 -->
			<div v-if="active==5">
				<div class="finish_box">
					<img src="@/assets/images/10972@3x.png" alt="">
					<div>
						登记成功
					</div>
					<div>
						可返回工作台继续办理业务，或打印回执单
					</div>
					<div>
						<el-button type="primary" @click="toWorktable">返回工作台</el-button>
						<el-button>打印回执单</el-button>
					</div>
				</div>
			</div>
		</div>
		<div class="footer" v-if="active<5">
			<div>
				<el-button @click="previousStep" class="cancel"><i class="el-icon-arrow-left"></i>
					<span v-if="active===0" >返回工作台</span>
					<span v-else>上一步</span>
				</el-button>
				<el-button type="primary" class="confirm" @click="nextStep">
					<span v-if="active==4">完成登记</span>
					<span v-else>下一步</span>
					<i class="el-icon-arrow-right"></i>
				</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	import step from '@/components/step.vue'
	export default {
		components: {
			step
		},
		data() {
			return {
				width: '197px',
				active: 0,
				stepArr: [{
						title: '选择单位'
					},
					{
						title: '选择资质'
					},
					{
						title: '处理资料'
					},
					{
						title: '清单信息'
					},
					{
						title: '经办人信息'
					},
					{
						title: '完成'
					},
				],
				value: '',
				ismilitary: -1,
				isGradeA: -1,
				isGradeB: -1,
				iscarrierA: -1,
				iscarrierB: -1,
				militarys: ['军工一级', '军工二级'],
				integratedGradeA: ['总体集成', '总体集成', '总体集成', '总体集成', '总体集成', '总体集成', '总体集成', '总体集成'],
				integratedGradeB: ['总体集成', '总体集成', '总体集成', '总体集成', '总体集成', '总体集成', '总体集成', '总体集成'],
				carrierA: ['涉密文件资料', '涉密文件资料', '涉密文件资料', '涉密文件资料', ],
				carrierB: ['涉密文件资料', '涉密文件资料', '涉密文件资料', '涉密文件资料', ],
				tableData: [{
					date: '印制资质',
					name: '甲级',
					address: '涉密文件资料',
					status: '0'
				}, {
					date: '印制资质',
					name: '乙级',
					address: '涉密文件资料',
					status: '1'
				}],
				infoLsit: [{
					type: '',
					num: '',
					memo: ''
				}, {
					type: '',
					num: '',
					memo: ''
				}],
				options: [{
					value: '1',
					label: '黄金糕'
				}],
				isagents: -1,
				agentList: [{
						name: '周思来',
						card: '450521196201181881',
						phone: '135 5624 5987'
					},
					{
						name: '赵轩海',
						card: '450521196201181881',
						phone: '135 5624 5987'
					}
				]
			};
		},
		created() {
		},
		methods: {
			toWorktable() {
				this.active = 0
				this.ismilitary = -1
				this.isGradeA = -1
				this.isGradeB = -1
				this.iscarrierA = -1
				this.iscarrierB = -1
				this.$router.go('-1')
			},
			previousStep() {
				if(this.active==0){
					this.toWorktable()
				}else{
					this.active -= 1
				}
			},
			nextStep() {
				this.active += 1
			},
			military(val) {
				console.log(val, this.ismilitary);
				if (val == this.ismilitary) {
					this.ismilitary = -1
				} else {
					this.ismilitary = val
				}
			},
			agent(val) {
				if (val == this.isagents) {
					this.isagents = -1
				} else {
					this.isagents = val
				}
			}
		}

	}
</script>

<style lang="less" scoped>
	.unitdetails {
		width: 100%;

		.step {
			height: 170px;
			background-color: #2258bf;
			box-shadow: 0px 7px 21px 0px rgba(0, 0, 0, 0.16);
			margin: 24px 24px 0 24px;
			padding: 27px 40px;
			box-sizing: border-box;
			border-radius: 16px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.step_title {
				font-size: 24px;
				line-height: 41px;
				color: #ffffff;
			}

			.step_content {
				width: 1148px;
				height: 41px;
				text-align: center;
				line-height: 41px;

				.item {
					width: 197px;
					height: 41px;
					background-color: #ffffff;
					opacity: 0.95;

				}
			}
		}

		.content {
			// height: 643px;
			min-height: 643px;
			background-color: #ffffff;
			margin: 16px 24px 96px 24px;
			border-radius: 16px;
			padding: 24px;
			box-sizing: border-box;
			box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.05);

			.title {
				height: 31px;
				font-size: 24px;
				color: #24262b;
			}

			.content_box {
				margin-top: 32px;
				height: 532px;
				background-color: #f5f6fa;
				border-radius: 8px;
				display: flex;
				justify-content: center; //水平居中
				align-items: center; //垂直居中

				.el-input {
					background-color: #ffffff;
					width: 509px;
					box-shadow: 0px 3px 9px 0px rgba(0, 0, 0, 0.16);
					border-radius: 8px;

				}

			}

			.my_table {
				margin-top: 32px;

				img {
					width: 40px;
					height: 40px;
					margin-right: 16px;
				}

				.column {
					display: flex;
					align-items: center;
				}
			}

			.qualification {

				.qualification_item {
					padding-bottom: 24px;
					box-sizing: border-box;
					border-bottom: solid 1px #eeeeee;

					.item_title {
						font-size: 16px;
						// line-height: 24px;
						margin: 16px 0;
						color: #24262b;
					}

					.item_cont {
						display: flex;
						flex-wrap: wrap;

						.contdome {
							width: 160px;
							height: 40px;
							margin-bottom: 16px;
							background-color: #ffffff;
							box-shadow: 0px 2px 4px 0px rgba(196, 196, 196, 0.2);
							border-radius: 4px;
							border: solid 1px #c4c4c4;
							margin-left: 32px;
							// margin-top: 16px;
							text-align: center;
							line-height: 40px;
							position: relative;

							img {
								position: absolute;
								bottom: 0;
								right: 0;
								width: 20px;
								height: 17px;
							}
						}

						.contdome:hover {
							color: #0147eb;
							border: solid 1px #0147eb;
						}

						.contdome_active {
							box-shadow: 0px 8px 8px 0px rgba(0, 58, 194, 0.2);
							border-radius: 4px;
							color: #0147eb;
							border: solid 1px #0147eb;
						}
					}
				}
			}

			.list_box {
				.list_title {
					margin: 32px 0 25px 0;
				}

				.check_box {
					background-color: #f5f6fa;
					border-radius: 8px;
					padding: 16px;
					box-sizing: border-box;

					.item {
						padding: 24px;
						box-sizing: border-box;
						display: flex;
						align-items: center;

						img {
							width: 40px;
							height: 40px;
							margin: 0 16px;
						}

						span {
							display: inline-block;
						}

						span:nth-child(1) {
							width: 249px;
						}

						span:nth-child(2) {
							width: 150px;
							display: flex;
							align-items: center;
						}

						span:nth-child(3) {
							width: 80px;
						}

						span:nth-child(4) {
							width: 100px;
						}

						span:nth-child(5) {
							color: #0147eb;
						}

					}
				}

				.info_box {
					border: solid 1px #e1e2e6;
					border-radius: 7px;
					overflow: hidden;
					margin-bottom: 17px;
					.info_title {
						padding: 15px 24px 14px 24px;
						box-sizing: border-box;
						background-color: #ebecf0;
						font-size: 14px;
						font-weight: bold;
						color: #545454;
					}

					.info_item {
						padding: 24px;
						box-sizing: border-box;
						background-color: #ffffff;
						border-top: solid 1px #e1e2e6;

						.el-form-item {
							margin: 0;
						}

						.operate_box {
							margin-left: 45px;
							font-size: 24px;

							i {
								margin-right: 18px;
							}
						}

					}
				}
			}

			.agent_box {
				display: flex;
				flex-wrap: wrap;
				margin-top: 72px;

				.agent_active {
					background-color: #ffffff !important;
					box-shadow: 0px 16px 16px 0px rgba(0, 58, 194, 0.2);
					border: solid 1px #0147eb;
				}

				.agent_item {
					width: 370px;
					height: 136px;
					margin: 0 16px 16px 0;
					background-color: #f5f6fa;
					border-radius: 8px;
					padding: 24px;
					box-sizing: border-box;
					display: flex;
					position: relative;

					.item_img {
						width: 80px;
						height: 80px;
						margin-right: 24px;

						img {
							width: 80px;
							height: 80px;
						}
					}

					.isagent {
						position: absolute;
						width: 38px;
						height: 33px;
						bottom: 0;
						right: 0;
					}

					.item_info {
						display: flex;
						flex-direction: column;
						justify-content: space-between;

						div {
							font-family: Microsoft YaHei;
							font-size: 14px;
							font-weight: normal;
							font-stretch: normal;
							color: #545454;

							i {
								margin-right: 10px;
							}
						}

						div:nth-child(1) {
							font-size: 20px;
							color: #24262b;
							font-weight: 700;
						}

					}
				}

				.agent_add {
					width: 370px;
					height: 136px;
					font-size: 16px;
					color: #0147eb;
					background-color: #ffffff;
					border-radius: 8px;
					border: dashed 1px #c4c4c4;
					display: flex;
					justify-content: space-around;
					align-items: center;
				}
			}

			.finish_box {
				width: 300px;
				text-align: center;
				margin: 150px auto 0;

				img {
					width: 88px;
					height: 88px;
					margin: 18px;
				}

				div:nth-of-type(1) {
					font-size: 24px;
					font-weight: bold;
					color: #24262b;
				}

				div:nth-of-type(2) {
					font-size: 14px;
					color: #545454;
					margin: 8px 0 24px 0;
				}
			}
		}

		.footer {
			position: fixed;
			bottom: 0;
			// width: 100%;
			height: 80px;
			background-color: #ffffff;
			box-shadow: 0px -4px 6px 0px rgba(0, 0, 0, 0.05);
			display: flex;
			align-items: center;
			justify-content: center; //水平居中
			width: calc(100% - 232px);

			.el-button {
				width: 200px;
				height: 56px;
			}
		}
	}
</style>
